import { useState, useEffect } from "react"
import IbanInquiry from "../../../components/Iban-inquiry"
import WithSidebar from "../../../layouts/WithSidebar"
import { useLocation } from "react-router-dom"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'




const InquiryIbanPage = () => {

    const {state} = useLocation()
    const [data, setData] = useState({})
    const {enqueueSnackbar} = useSnackbar()

    const inqueryIban = async() => {
        const response = await ajax({
            method: 'GET',
            url: utils.urls.ibanInquiry(state),
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!response) return

        console.log(response, 'get inquiry')
        setData(response.data)

    }

    useEffect ( () => {
        // console.log(state, 'erererere')
        inqueryIban()
    }, [])

    return (
        <WithSidebar>
            <IbanInquiry  data={data} id={state}/>
        </WithSidebar>
    )
}

export default InquiryIbanPage